// src/components/repasses/components/ToolbarToolsRepasse.tsx

import { Download as DownloadIcon, PlayArrow as PlayArrowIcon, UploadFile as UploadFileIcon } from "@mui/icons-material";
import { Box, Button, Toolbar, Select, MenuItem, FormControl, InputLabel } from "@mui/material";

interface Props {
	onFileImport: (file: File) => void;
	onAnalyze: (dateFilter: string) => void;
	onDownloadModel: () => void;
	onExportResult: () => void;
	dateFilter: string;
	onDateFilterChange: (filter: string) => void;
}

/**
 * Gera uma lista de opções de filtro de data: Mês Atual, Mês Anterior,
 * todos os meses do ano atual e os próximos dois meses.
 */
const generateMonthOptions = () => {
	const now = new Date();
	const currentMonth = now.getMonth();
	const currentYear = now.getFullYear();
	const monthNames = ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"];

	const options = [
		// Opções fixas
		{ value: "current_month", label: "Mês Atual" },
		{ value: "previous_month", label: "Mês Anterior" },
		{ value: "", label: "--- Selecionar Mês ---", disabled: true },
	];

	// 1. Gera opções para os meses do ano atual
	for (let month = 0; month < 12; month++) {
		options.push({
			value: String(month),
			label: `${monthNames[month]} / ${currentYear}`,
		});
	}

	// 2. Adiciona os próximos 2 meses
	for (let i = 1; i <= 2; i++) {
		const futureDate = new Date(currentYear, currentMonth + i, 1);
		const futureMonth = futureDate.getMonth();
		const futureYear = futureDate.getFullYear();
		const isNextYear = futureYear > currentYear;

		options.push({
			value: String(futureMonth),
			label: `${monthNames[futureMonth]} / ${futureYear}${isNextYear ? " (Próximo Ano)" : ""}`,
		});
	}

	return options;
};

export const ToolbarToolsRepasse = ({ onFileImport, onAnalyze, onDownloadModel, onExportResult, dateFilter, onDateFilterChange }: Props) => {
	const dateOptions = generateMonthOptions();

	return (
		// O justify-content: space-between garante que os dois Boxes fiquem nas extremidades
		<Toolbar sx={{ px: 0, gap: 4, justifyContent: "space-between" }}>
			{/* Grupo ESQUERDO: Filtro, Importar e Verificar */}
			<Box display="flex" alignItems="center" gap={2}>
				{/* Filtro de Data */}
				<FormControl variant="outlined" size="small" sx={{ minWidth: 200 }}>
					<InputLabel>Período de Vencimento</InputLabel>
					<Select value={dateFilter} onChange={(e) => onDateFilterChange(e.target.value as string)} label="Período de Vencimento">
						{dateOptions.map((option) => (
							<MenuItem key={option.value} value={option.value} disabled={(option as any).disabled}>
								{option.label}
							</MenuItem>
						))}
					</Select>
				</FormControl>

				{/* Botão Importar */}
				<Button variant="outlined" startIcon={<UploadFileIcon />} component="label">
					Importar
					<input
						type="file"
						hidden
						accept=".csv"
						onChange={(e) => {
							const file = e.target.files?.[0];
							if (file) {
								onFileImport(file);
								e.target.value = "";
							}
						}}
					/>
				</Button>

				{/* Botão Verificar */}
				<Button variant="outlined" color="info" startIcon={<PlayArrowIcon />} onClick={() => onAnalyze(dateFilter)}>
					Verificar
				</Button>
			</Box>

			{/* Grupo DIREITO: Ações de Download/Exportação */}
			<Box display="flex" alignItems="center" gap={1}>
				<Button variant="text" color="primary" startIcon={<DownloadIcon />} onClick={onDownloadModel}>
					Baixar Modelo
				</Button>

				<Button variant="text" color="secondary" startIcon={<DownloadIcon />} onClick={onExportResult}>
					Exportar Resultado
				</Button>
			</Box>
		</Toolbar>
	);
};
